import { useQuery } from "@tanstack/react-query";
import { DevourPlayApi, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export type TimeFilter = "day" | "week" | "month" | "year" | "all";

export const useGetPlayStats = (
    fullToken: Token | null | undefined,
    timeFilter: TimeFilter = "all",
) => {
    return useQuery({
        queryKey: ["play-stats", fullToken?.token, timeFilter],
        queryFn: async () => {
            if (!fullToken?.token) {
                throw new Error("No authentication token");
            }
            return new DevourPlayApi(getConfig(fullToken)).getDevourplayPlayStats({
                timeFilter: timeFilter as any,
            });
        },
        enabled: !!fullToken?.token,
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
    });
};
